import React from "react";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "../../icons";

type SectionExpandableProps = {
  label: string;
  children: React.ReactNode;
  transparent?: boolean;
  defaultOpen?: boolean;
};

const SectionExpandable = ({ label, children, transparent = false, defaultOpen = false }: SectionExpandableProps) => {
  return (
    <Disclosure as="div" className="space-y-4" defaultOpen={defaultOpen}>
      {({ open }) => (
        <>
          <Disclosure.Button
            className={`${
              transparent ? "bg-transparent" : "bg-white hover:bg-gray-50"
            } text-gray-800 hover:text-gray-900 group w-full flex items-center p-2 text-left text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500`}
          >
            <ChevronDownIcon
              className={`${open ? "text-gray-400" : "text-gray-300 -rotate-90"}
                 mr-1 flex-shrink-0 h-4 w-4 transform group-hover:text-gray-400 transition-colors transition-transform ease-in-out duration-150`}
            />
            {label}
          </Disclosure.Button>
          <Disclosure.Panel className="space-y-6 px-7">{children}</Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default SectionExpandable;
